import { CircularProgress } from "@suraasa/placebo-ui"
import React, { useEffect, useMemo, useRef, useState } from "react"

const DEFAULT_HEIGHT = 0

const IFrame = ({
  url,
  id,
  render,
  onLoaded,
}: {
  url: string
  id: string
  render?: (props: { isLoading: boolean }) => React.ReactNode
  onLoaded?: () => void
}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null)
  const [iframeHeight, setIframeHeight] = useState(DEFAULT_HEIGHT)

  const isLoading = useMemo(
    () => iframeHeight === DEFAULT_HEIGHT,
    [iframeHeight]
  )

  useEffect(() => {
    if (!isLoading && onLoaded) {
      onLoaded()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.data?.type === "iframeHeight" &&
        typeof event.data.height === "number"
      ) {
        setIframeHeight(event.data.height)
      }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])
  return (
    <>
      {isLoading && (
        <div className="absolute grid size-full place-items-center bg-white p-4">
          <CircularProgress color="black" size="lg" />
        </div>
      )}
      <iframe
        ref={iframeRef}
        src={url}
        width="100%"
        height="100%"
        style={{
          height: iframeHeight + 50,
        }}
        id={id}
        title={id}
      />
      {render && render({ isLoading })}
    </>
  )
}

export default IFrame
